/**
 * ADR-222 — «مشاركة السلة» on the web: the cart becomes the same `?add=` link
 * Desk sends (ADR-218). One delegated listener (the drawer re-renders its
 * section). Wire rules: ErosReorderWire.cartShareWire, shared with the app.
 */
(function () {
  'use strict';
  if (window.__erosCartShareBound) return;
  window.__erosCartShareBound = true;

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function toast(message) {
    if (message && window.ErosUI && typeof window.ErosUI.toast === 'function') window.ErosUI.toast(message);
  }

  function syncVisibility(cart) {
    var empty = !cart || !cart.item_count;
    document.querySelectorAll('[data-eros-cart-share]').forEach(function (b) { b.hidden = empty; });
  }

  function share(button) {
    var W = window.ErosReorderWire;
    if (!W) return;
    fetch(routesRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = W.cartShareWire((cart.items || []).map(function (i) { return { v: i.variant_id, q: i.quantity }; }));
        if (!link.wire) return;
        var url = 'https://erosstore.co/cart?add=' + link.wire;
        var text = button.getAttribute('data-share-text') || '';
        if (link.truncated) toast(button.getAttribute('data-truncated'));
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'share', { method: 'cart_link', content_type: 'cart', item_count: link.wire.split(',').length });
        }
        if (navigator.share) {
          return navigator.share({ text: text, url: url }).catch(function () { /* dismissed */ });
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(text + '\n' + url).then(function () {
            toast(button.getAttribute('data-copied'));
          });
        }
      })
      .catch(function () { /* offline: nothing to share */ });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-eros-cart-share]');
    if (!button) return;
    e.preventDefault();
    share(button);
  });
  document.addEventListener('cart:change', function (e) {
    syncVisibility(e.detail && e.detail.cart);
  });
})();
